import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';
import type { GuardProps } from 'types';

export default function AdminGuard({ children }: GuardProps) {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
      return;
    }
    if (!user?.admin) {
      navigate(DASHBOARD_PATH, { replace: true });
    }
  }, [isLoggedIn, user?.admin, navigate]);

  if (!isLoggedIn || !user?.admin) {
    return null;
  }

  return <>{children}</>;
}
